export const CHANGE_STATE = 'CHANGE_STATE'
export const SETUP_QCAA = 'SETUP_QCAA'
export const CLEAR_ALL_AARA = 'CLEAR_ALL_AARA'